<template>
  <div class="payment">
    <payment></payment>

    <my_button value="已完成支付" @click.native="back"></my_button>
  </div>
</template>

<script>
import Payment from '@/components/contest/Payment.vue'
import MyButton from '@/components/Button.vue'
export default {
  name: 'Payment',
  components: {
    payment: Payment,
    my_button: MyButton
  },
  methods: {
    back () {
      this.$http.get('/api/login/me').then(res => {
        this.$store.commit('SET_USER', res.data)
        if (res.data.paid) {
          this.$store.commit('UNSET_REDIRECT')
          this.$router.history.go(-1)
        }
      })
          this.$router.history.go(-1)
    }
  }
}

</script>

<style scoped>

.payment {
   margin-top: 5.2vw;
   margin-bottom: 5.2vw;
   display: flex;
   justify-content: center;
   flex-direction: column;
   align-items:center;
}

</style>